// extracted by mini-css-extract-plugin
export default {"root":"Home_root__tg6u2","content":"Home_content__YXR+f","sep":"Home_sep__cnJsT"};